import { Filter, FilterGroup, FilterOperator, SortOrder } from "../types.gen";

export type SearchInputBase = {
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string;
  sortDir?: SortOrder;
  filterOperator?: FilterOperator;
  filterFilters?: Filter[];
  filterFilterGroups?: FilterGroup[];
}

// Function so new array refs are created on each call
export class SearchInput implements SearchInputBase {
  pageSize = 24
  pageNumber = 0
  sortBy = 'occurred'
  sortDir = SortOrder.Descending
  filterOperator = FilterOperator.And
  filterFilters: Filter[] = []
  filterFilterGroups: FilterGroup[] = []
  private extra: Record<PropertyKey, any> = {}

  constructor(
    init?: SearchInputBase
  ) {
    this.pageSize = init?.pageSize ?? 24;
    this.pageNumber = init?.pageNumber ?? 0;
    this.sortBy = init?.sortBy ?? 'occurred';
    this.sortDir = init?.sortDir ?? SortOrder.Descending;
    this.filterOperator = init?.filterOperator ?? FilterOperator.And;
    this.filterFilters = init?.filterFilters ?? [];
    this.filterFilterGroups = init?.filterFilterGroups ?? [];
  }

  /**
   * Adds an arbitrary key to the resulting params
   */
  add(key: string, value: any) {
    this.extra[key] = value
  }

  /** 
   * Convert to an object that axios will correctly sarialise to qparams 
   */
  toParams() {
    return {
      PageNumber: this.pageNumber,
      PageSize: this.pageSize,
      SortBy: this.sortBy,
      SortDir: this.sortDir,
      'Filter.Operator': this.filterOperator,
      'Filter.Filters': this.filterFilters,
      'Filter.FilterGroups': this.filterFilterGroups,
      ...this.extra,
    } as const
  }
}